var map = {
	"./Accipiter badius.jpg": 79385,
	"./Accipiter brevipes.png": 31753,
	"./Accipiter cirrocephalus.png": 43115,
	"./Accipiter fasciatus.png": 80750,
	"./Accipiter gentilis.jpg": 29846,
	"./Accipiter gularis.jpg": 4470,
	"./Accipiter melanoleucus.png": 18692,
	"./Accipiter minullus.png": 77458,
	"./Accipiter nisus.jpg": 26657,
	"./Accipiter novaehollandiae.png": 8705,
	"./Accipiter ovampensis.png": 32702,
	"./Accipiter rufiventris.png": 45102,
	"./Accipiter soloensis.jpg": 82188,
	"./Accipiter tachiro.png": 44947,
	"./Accipiter trivirgatus.jpg": 93357,
	"./Accipiter virgatus.jpg": 49434,
	"./Aceros nipalensis.jpg": 86166,
	"./Acrocephalus griseldis.png": 67747,
	"./Acrocephalus tangorum.jpg": 74838,
	"./Actitis hypoleucos.jpg": 89305,
	"./Aegypius monachus.jpg": 37602,
	"./Aerodramus unicolor.jpg": 76975,
	"./Agapornis pullarius.png": 77558,
	"./Alisterus scapularis.png": 25134,
	"./Alophoixus tephrogenys.jpg": 19941,
	"./Amaurornis phoenicurus.png": 85467,
	"./Anas castanea.png": 25204,
	"./Anas gracilis.png": 50978,
	"./Anas superciliosa.png": 79309,
	"./Anastomus lamelligerus.png": 68522,
	"./Anastomus oscitans.jpg": 87306,
	"./Anhinga melanogaster.jpg": 63881,
	"./Anhinga novaehollandiae.png": 83705,
	"./Anhinga rufa.png": 50271,
	"./Anorrhinus austeni.jpg": 88275,
	"./Anorrhinus galeritus.jpg": 75670,
	"./Anorrhinus tickelli.jpg": 78643,
	"./Anous minutus.png": 56222,
	"./Anous stolidus.jpg": 2566,
	"./Anous tenuirostris.jpg": 61310,
	"./Anser erythropus.png": 2923,
	"./Anseranas semipalmata.png": 77687,
	"./Anthracoceros albirostris.png": 1303,
	"./Anthracoceros coronatus.jpg": 92797,
	"./Anthracoceros malayanus.jpg": 92908,
	"./Anthropoides virgo.jpg": 26504,
	"./Anthus cervinus.png": 59803,
	"./Anthus hodgsoni.png": 94235,
	"./Anthus lineiventris.png": 96422,
	"./Anthus melindae.png": 84181,
	"./Anthus nilghiriensis.jpg": 9098,
	"./Anthus richardi.png": 90308,
	"./Anthus rufulus.png": 87196,
	"./Anthus similis.png": 24950,
	"./Anthus sokokensis.png": 70811,
	"./Aphrodroma brevirostris.png": 40008,
	"./Aplonis metallica.png": 31855,
	"./Aplopelia larvata.png": 83727,
	"./Aprosmictus erythropterus.png": 63785,
	"./Apus acuticauda.jpg": 61956,
	"./Apus pacificus.png": 30347,
	"./Aquila audax.png": 80849,
	"./Aquila chrysaetos.jpg": 53181,
	"./Aquila fasciata.jpg": 84944,
	"./Aquila heliaca.jpg": 17461,
	"./Aquila nipalensis.jpg": 67040,
	"./Aquila rapax.jpg": 55926,
	"./Aquila spilogaster.png": 96493,
	"./Aquila verreauxii.png": 92802,
	"./Arborophila atrogularis.jpg": 94837,
	"./Arborophila chloropus.jpg": 81471,
	"./Arborophila davidi.jpg": 94467,
	"./Arborophila rufogularis.jpg": 42065,
	"./Arborophila torqueola.jpg": 75274,
	"./Ardea alba.png": 9754,
	"./Ardea cinerea.png": 70021,
	"./Ardea goliath.png": 36832,
	"./Ardea insignis.jpg": 23264,
	"./Ardea intermedia.png": 49840,
	"./Ardea pacifica.png": 3136,
	"./Ardea plumifera.png": 96899,
	"./Ardea purpurea.png": 53634,
	"./Ardea sumatrana.png": 11446,
	"./Ardenna bulleri.png": 10815,
	"./Ardenna carneipes.jpg": 88450,
	"./Ardenna grisea.png": 9107,
	"./Ardenna pacifica.jpg": 63504,
	"./Ardenna tenuirostris.png": 5861,
	"./Ardeola bacchus.png": 13624,
	"./Ardeola grayii.jpg": 34376,
	"./Ardeola idae.png": 60870,
	"./Ardeotis australis.png": 63196,
	"./Ardeotis kori.png": 57275,
	"./Ardeotis nigriceps.jpg": 91470,
	"./Arenaria interpres.jpg": 15566,
	"./Artamus fuscus.jpg": 61003,
	"./Asarcornis scutulata.jpg": 45880,
	"./Asio abyssinicus.png": 85316,
	"./Asio capensis.png": 61373,
	"./Asio flammeus.jpg": 55919,
	"./Asio otus.jpg": 64912,
	"./Athene blewitti.jpg": 30806,
	"./Athene brama.jpg": 46647,
	"./Athene noctua.jpg": 19172,
	"./Aviceda cuculoides.png": 21020,
	"./Aviceda jerdoni.jpg": 35053,
	"./Aviceda leuphotes.jpg": 70825,
	"./Aviceda subcristata.png": 23923,
	"./Aythya australis.png": 89353,
	"./Aythya baeri.jpg": 90234,
	"./Aythya ferina.jpg": 65098,
	"./Aythya fuligula.png": 44686,
	"./Aythya nyroca.jpg": 31031,
	"./Balearica pavonina.png": 93269,
	"./Balearica regulorum.png": 35781,
	"./Bambusicola fytchii.jpg": 83175,
	"./Barnardius zonarius.png": 72977,
	"./Berenicornis comatus.jpg": 54540,
	"./Bostrychia hagedash.png": 32024,
	"./Bostrychia olivacea.png": 47667,
	"./Botaurus poiciloptilus.png": 69988,
	"./Brachypodius priocephalus.jpg": 92633,
	"./Bubo africanus.png": 5143,
	"./Bubo bengalensis.jpg": 40016,
	"./Bubo bubo.jpg": 8005,
	"./Bubo capensis.png": 71907,
	"./Bubo cinerascens.png": 59993,
	"./Bubo coromandus.jpg": 6480,
	"./Bubo lacteus.png": 83398,
	"./Bubo nipalensis.png": 28689,
	"./Bubo sumatranus.jpg": 86982,
	"./Bubulcus ibis.png": 11473,
	"./Buceros bicornis.jpg": 98335,
	"./Buceros rhinoceros.jpg": 72756,
	"./Bucorvus abyssinicus.png": 17613,
	"./Bucorvus leadbeateri.png": 36564,
	"./Bulweria bulwerii.jpg": 14267,
	"./Bulweria fallax.jpg": 76260,
	"./Burhinus capensis.png": 69005,
	"./Burhinus grallarius.png": 89095,
	"./Burhinus indicus.jpg": 91938,
	"./Burhinus oedicnemus.png": 99725,
	"./Burhinus senegalensis.png": 41850,
	"./Burhinus vermiculatus.png": 80869,
	"./Butastur indicus.jpg": 28012,
	"./Butastur liventer.jpg": 78862,
	"./Butastur rufipennis.png": 42994,
	"./Butastur teesa.jpg": 95237,
	"./Buteo augur.png": 47140,
	"./Buteo buteo.jpg": 95649,
	"./Buteo hemilasius.jpg": 21808,
	"./Buteo japonicus.jpg": 23530,
	"./Buteo lagopus.png": 10713,
	"./Buteo oreophilus.png": 93674,
	"./Buteo refectus.jpg": 70315,
	"./Buteo rufinus.jpg": 96654,
	"./Butorides striata.png": 43918,
	"./Bycanistes brevis.png": 77247,
	"./Bycanistes bucinator.png": 35815,
	"./Bycanistes subcylindricus.png": 17719,
	"./Cacatua galerita.png": 14812,
	"./Cacatua leadbeateri.png": 87295,
	"./Cacatua pastinator.png": 90670,
	"./Cacatua sanguinea.png": 22506,
	"./Cacatua tenuirostris.png": 66844,
	"./Calendulauda poecilosterna.png": 13782,
	"./Calidris acuminata.png": 7907,
	"./Calidris alba.jpg": 63232,
	"./Calidris alpina.jpg": 93501,
	"./Calidris canutus.jpg": 30995,
	"./Calidris falcinellus.jpg": 31944,
	"./Calidris ferruginea.jpg": 67768,
	"./Calidris minuta.jpg": 79400,
	"./Calidris pugnax.jpg": 29769,
	"./Calidris pygmaea.jpg": 60774,
	"./Calidris ruficollis.jpg": 91410,
	"./Calidris subminuta.jpg": 44552,
	"./Calidris temminckii.jpg": 52066,
	"./Calidris tenuirostris.jpg": 52895,
	"./Caligavis chrysops.png": 62069,
	"./Calliope obscura.png": 96673,
	"./Callocephalon fimbriatum.png": 61332,
	"./Calonectris diomedea.png": 19530,
	"./Calonectris leucomelas.jpg": 8960,
	"./Calyptorhynchus banksii.png": 22144,
	"./Calyptorhynchus lathami.png": 60683,
	"./Campethera mombassica.png": 93706,
	"./Campocolinus coqui.png": 34717,
	"./Carpococcyx renauldi.jpg": 53545,
	"./Catharacta antarctica.png": 71625,
	"./Catreus wallichii.jpg": 63848,
	"./Centropus rectunguis.jpg": 80665,
	"./Cereopsis novaehollandiae.png": 51582,
	"./Chalcophaps indica.png": 78223,
	"./Charadrius alexandrinus.jpg": 44831,
	"./Charadrius asiaticus.png": 90327,
	"./Charadrius bicinctus.png": 65847,
	"./Charadrius dealbatus.jpg": 63910,
	"./Charadrius dubius.jpg": 6683,
	"./Charadrius hiaticula.jpg": 62811,
	"./Charadrius leschenaultii.jpg": 17945,
	"./Charadrius marginatus.png": 84252,
	"./Charadrius mongolus.jpg": 31113,
	"./Charadrius pallidus.png": 77967,
	"./Charadrius pecuarius.png": 73288,
	"./Charadrius peronii.jpg": 81813,
	"./Charadrius placidus.jpg": 16386,
	"./Charadrius ruficapillus.png": 328,
	"./Charadrius tricollaris.png": 37033,
	"./Charadrius veredus.jpg": 14637,
	"./Chelictinia riocourii.png": 88579,
	"./Chenonetta jubata.png": 49643,
	"./Chersophilus duponti.png": 56529,
	"./Chlamydotis macqueenii.jpg": 93955,
	"./Chlamydotis undulata.png": 52252,
	"./Chlidonias hybrida.png": 33934,
	"./Chlidonias leucopterus.png": 79016,
	"./Chlidonias niger.png": 91042,
	"./Ciconia abdimii.png": 66772,
	"./Ciconia ciconia.jpg": 51685,
	"./Ciconia episcopus.jpg": 84260,
	"./Ciconia nigra.jpg": 91214,
	"./Ciconia stormi.jpg": 2595,
	"./Circaetus beaudouini.png": 60061,
	"./Circaetus cinerascens.png": 70114,
	"./Circaetus cinereus.png": 19282,
	"./Circaetus fasciolatus.png": 87224,
	"./Circaetus gallicus.jpg": 91278,
	"./Circaetus pectoralis.png": 6354,
	"./Circus aeruginosus.jpg": 16995,
	"./Circus approximans.png": 32242,
	"./Circus assimilis.png": 18646,
	"./Circus cyaneus.jpg": 77762,
	"./Circus macrourus.jpg": 53725,
	"./Circus melanoleucos.jpg": 39895,
	"./Circus pygargus.jpg": 85794,
	"./Circus ranivorus.png": 23465,
	"./Circus spilonotus.jpg": 58702,
	"./Cissa chinensis.jpg": 96606,
	"./Cissa hypoleuca.jpg": 42706,
	"./Cladorhynchus leucocephalus.png": 8993,
	"./Clanga clanga.jpg": 90081,
	"./Clanga hastata.jpg": 26165,
	"./Clanga pomarina.png": 32856,
	"./Columba arquatrix.png": 17235,
	"./Columba delegorguei.png": 75376,
	"./Columba elphinstonii.jpg": 20674,
	"./Columba eversmanni.jpg": 38974,
	"./Columba guinea.png": 88927,
	"./Columba hodgsonii.png": 5344,
	"./Columba leucomela.png": 55741,
	"./Columba livia.png": 27225,
	"./Columba oenas.png": 55116,
	"./Columba palumbus.png": 84233,
	"./Columba pulchricollis.png": 58165,
	"./Columba punicea.jpg": 24181,
	"./Coracias abyssinicus.png": 83617,
	"./Coracias affinis.png": 20528,
	"./Coracias benghalensis.jpg": 59261,
	"./Coracias caudatus.png": 51914,
	"./Coracias garrulus.png": 38213,
	"./Coracias naevius.png": 95339,
	"./Corcorax melanorhamphos.png": 3608,
	"./Corvus albicollis.png": 30525,
	"./Corvus albus.png": 44960,
	"./Corvus bennetti.png": 87222,
	"./Corvus capensis.png": 76587,
	"./Corvus corax.jpg": 34396,
	"./Corvus corone.jpg": 9551,
	"./Corvus coronoides.png": 57046,
	"./Corvus edithae.png": 28729,
	"./Corvus frugilegus.jpg": 98372,
	"./Corvus macrorhynchos.jpg": 79271,
	"./Corvus mellori.png": 13945,
	"./Corvus orru.png": 25619,
	"./Corvus pectoralis.jpg": 87491,
	"./Corvus rhipidurus.png": 56780,
	"./Corvus ruficollis.png": 86805,
	"./Corvus splendens.jpg": 41153,
	"./Corvus tasmanicus.png": 43679,
	"./Coturnix coromandelica.jpg": 52184,
	"./Coturnix delegorguei.png": 44179,
	"./Coturnix japonica.jpg": 17342,
	"./Cracticus mentalis.png": 34461,
	"./Cracticus nigrogularis.png": 73110,
	"./Cracticus torquatus.png": 60262,
	"./Crypsirina temia.jpg": 14457,
	"./Cursorius coromandelicus.jpg": 32476,
	"./Cursorius somalensis.png": 904,
	"./Cursorius temminckii.png": 63530,
	"./Cygnus atratus.png": 53074,
	"./Cygnus olor.png": 37594,
	"./Dacelo leachii.png": 85462,
	"./Dacelo novaeguineae.png": 52350,
	"./Daption capense.png": 59565,
	"./Dendrocitta formosae.jpg": 44358,
	"./Dendrocitta frontalis.jpg": 76580,
	"./Dendrocitta leucogastra.jpg": 6448,
	"./Dendrocitta vagabunda.jpg": 75209,
	"./Dendrocygna arcuata.png": 35784,
	"./Dendrocygna eytoni.png": 36305,
	"./Dendrocygna javanica.png": 38380,
	"./Dendronanthus indicus.png": 2639,
	"./Dicrurus bracteatus.png": 50538,
	"./Dicrurus caerulescens.jpg": 92295,
	"./Diomedea amsterdamensis.png": 83577,
	"./Diomedea antipodensis.png": 8410,
	"./Diomedea epomophora.png": 62127,
	"./Diomedea exulans.png": 61361,
	"./Diomedea sanfordi.png": 92291,
	"./Dromas ardeola.jpg": 77457,
	"./Ducula aenea.png": 52947,
	"./Ducula badia.png": 59286,
	"./Ducula spilorrhoa.png": 68278,
	"./Eclectus polychloros.png": 16777,
	"./Egretta eulophotes.jpg": 52093,
	"./Egretta garzetta.png": 91755,
	"./Egretta novaehollandiae.png": 76467,
	"./Egretta picata.png": 90973,
	"./Egretta sacra.png": 62661,
	"./Elanus axillaris.png": 97490,
	"./Elanus caeruleus.jpg": 89196,
	"./Elanus scriptus.png": 7678,
	"./Emberiza aureola.jpg": 29265,
	"./Eolophus roseicapilla.png": 54392,
	"./Ephippiorhynchus asiaticus.jpg": 74367,
	"./Ephippiorhynchus senegalensis.png": 94770,
	"./Erythrotriorchis radiatus.png": 9972,
	"./Esacus magnirostris.jpg": 64461,
	"./Esacus recurvirostris.jpg": 10475,
	"./Eudynamys orientalis.png": 13942,
	"./Eudyptula minor.png": 92015,
	"./Eupodotis senegalensis.png": 65600,
	"./Eurystomus glaucurus.png": 47010,
	"./Eurystomus orientalis.png": 71033,
	"./Falco alopex.png": 72905,
	"./Falco amurensis.jpg": 95103,
	"./Falco ardosiaceus.png": 69553,
	"./Falco berigora.png": 81269,
	"./Falco biarmicus.png": 65441,
	"./Falco cenchroides.png": 44315,
	"./Falco cherrug.jpg": 85456,
	"./Falco chicquera.jpg": 31557,
	"./Falco columbarius.jpg": 79942,
	"./Falco concolor.png": 44105,
	"./Falco cuvierii.png": 27212,
	"./Falco eleonorae.png": 36588,
	"./Falco fasciinucha.png": 47788,
	"./Falco hypoleucos.png": 82429,
	"./Falco jugger.jpg": 7272,
	"./Falco longipennis.png": 77320,
	"./Falco naumanni.jpg": 97243,
	"./Falco peregrinus.jpg": 52152,
	"./Falco ruficollis.png": 2394,
	"./Falco rupicoloides.png": 72400,
	"./Falco severus.jpg": 39993,
	"./Falco subbuteo.jpg": 30203,
	"./Falco subniger.png": 85693,
	"./Falco tinnunculus.jpg": 33342,
	"./Falco vespertinus.png": 62866,
	"./Ficedula subrubra.jpg": 26898,
	"./Francolinus francolinus.jpg": 1833,
	"./Francolinus gularis.jpg": 32468,
	"./Francolinus pictus.jpg": 44585,
	"./Francolinus pintadeanus.jpg": 59877,
	"./Francolinus pondicerianus.jpg": 33969,
	"./Fraseria lendu.png": 26162,
	"./Fregata andrewsi.jpg": 4914,
	"./Fregata ariel.jpg": 47492,
	"./Fregata minor.jpg": 16766,
	"./Fregatta tropica.jpg": 68219,
	"./Fulica atra.png": 7443,
	"./Fulmarus glacialoides.png": 28951,
	"./Gallicrex cinerea.png": 47777,
	"./Gallinago gallinago.jpg": 88361,
	"./Gallinago hardwickii.png": 94298,
	"./Gallinago media.png": 71289,
	"./Gallinago megala.jpg": 94746,
	"./Gallinago nemoricola.jpg": 9170,
	"./Gallinago nigripennis.png": 98397,
	"./Gallinago solitaria.jpg": 69191,
	"./Gallinago stenura.jpg": 55467,
	"./Galloperdix lunulata.jpg": 20598,
	"./Galloperdix spadicea.png": 3812,
	"./Gallus gallus.jpg": 2625,
	"./Gallus sonneratii.jpg": 96879,
	"./Garrodia nereis.png": 25180,
	"./Garrulus bispecularis.jpg": 30048,
	"./Garrulus lanceolatus.jpg": 8717,
	"./Garrulus leucotis.jpg": 11868,
	"./Gelochelidon macrotarsa.png": 48583,
	"./Gelochelidon nilotica.jpg": 48231,
	"./Geoffroyus geoffroyi.png": 2786,
	"./Glareola lactea.jpg": 17340,
	"./Glareola maldivarum.png": 30882,
	"./Glareola nordmanni.png": 46478,
	"./Glareola nuchalis.png": 87867,
	"./Glareola ocularis.png": 75858,
	"./Glareola pratincola.png": 92537,
	"./Glaucidium brodiei.jpg": 47833,
	"./Glaucidium capense.png": 28616,
	"./Glaucidium cuculoides.jpg": 9197,
	"./Glaucidium perlatum.png": 6179,
	"./Glaucidium radiatum.jpg": 89182,
	"./Glaucidium tephronotum.png": 67948,
	"./Grallina cyanoleuca.png": 46525,
	"./Grus antigone.jpg": 19785,
	"./Grus grus.jpg": 86387,
	"./Grus nigricollis.jpg": 41429,
	"./Grus rubicunda.png": 44613,
	"./Gulosus aristotelis.png": 74210,
	"./Gymnorhina tibicen.png": 39885,
	"./Gypaetus barbatus.jpg": 77183,
	"./Gypohierax angolensis.png": 14222,
	"./Gyps africanus.png": 75578,
	"./Gyps bengalensis.jpg": 53485,
	"./Gyps fulvus.jpg": 51525,
	"./Gyps himalayensis.jpg": 36057,
	"./Gyps indicus.jpg": 74085,
	"./Gyps rueppelli.png": 14900,
	"./Gyps tenuirostris.jpg": 82047,
	"./Haematopus fuliginosus.png": 13970,
	"./Haematopus longirostris.png": 56773,
	"./Haematopus ostralegus.jpg": 49933,
	"./Haliaeetus albicilla.jpg": 9385,
	"./Haliaeetus leucogaster.jpg": 82488,
	"./Haliaeetus leucogaster.png": 82940,
	"./Haliaeetus leucoryphus.jpg": 15211,
	"./Haliaeetus vocifer.png": 13824,
	"./Haliastur indus.jpg": 97911,
	"./Haliastur indus.png": 85735,
	"./Haliastur sphenurus.png": 23275,
	"./Halobaena caerulea.png": 23242,
	"./Hamirostra melanosternon.png": 17906,
	"./Heliopais personatus.jpg": 82691,
	"./Hieraaetus ayresii.png": 80338,
	"./Hieraaetus morphnoides.png": 34684,
	"./Hieraaetus pennatus.jpg": 796,
	"./Hieraaetus wahlbergi.png": 71767,
	"./Himalayapsitta cyanocephala.jpg": 55822,
	"./Himalayapsitta finschii.jpg": 53951,
	"./Himalayapsitta himalayana.jpg": 2157,
	"./Himalayapsitta roseata.jpg": 44007,
	"./Hirundapus caudacutus.png": 64504,
	"./Hirundo atrocaerulea.png": 77950,
	"./Houbaropsis bengalensis.jpg": 55827,
	"./Hydrobates matsudairae.png": 50082,
	"./Hydrobates monorhis.jpg": 40067,
	"./Hydrocoloeus minutus.png": 92194,
	"./Hydroprogne caspia.jpg": 36741,
	"./Hypocolius ampelinus.jpg": 21768,
	"./Ibidorhyncha struthersii.jpg": 2401,
	"./Icthyophaga humilis.jpg": 12021,
	"./Icthyophaga ichthyaetus.jpg": 16901,
	"./Ictinaetus malaiensis.jpg": 35266,
	"./Ithaginis cruentus.jpg": 87658,
	"./Ixobrychus flavicollis.png": 33225,
	"./Kaupifalco monogrammicus.png": 2263,
	"./Ketupa flavipes.jpg": 60253,
	"./Ketupa ketupu.jpg": 38165,
	"./Ketupa zeylonensis.jpg": 65252,
	"./Larus armenicus.png": 65575,
	"./Larus brunnicephalus.jpg": 28411,
	"./Larus cachinnans.png": 13796,
	"./Larus canus.jpg": 7446,
	"./Larus cirrocephalus.png": 48956,
	"./Larus dominicanus.png": 17472,
	"./Larus fuscus.jpg": 69639,
	"./Larus genei.jpg": 75812,
	"./Larus hemprichii.png": 83144,
	"./Larus ichthyaetus.png": 3273,
	"./Larus leucophthalmus.png": 20490,
	"./Larus melanocephalus.png": 76211,
	"./Larus michahellis.png": 62269,
	"./Larus novaehollandiae.png": 21410,
	"./Larus pacificus.png": 20173,
	"./Larus ridibundus.jpg": 66889,
	"./Larus smithsonianus.jpg": 1665,
	"./Lathamus discolor.png": 49133,
	"./Leptoptilos crumenifer.png": 8598,
	"./Leptoptilos dubius.jpg": 76688,
	"./Leptoptilos javanicus.jpg": 79274,
	"./Lerwa lerwa.jpg": 29941,
	"./Leucosarcia melanoleuca.png": 63258,
	"./Limnodromus semipalmatus.jpg": 8747,
	"./Limosa lapponica.jpg": 29731,
	"./Limosa limosa.jpg": 12667,
	"./Lissotis hartlaubii.png": 89150,
	"./Lissotis melanogaster.png": 78877,
	"./Lophaetus occipitalis.png": 53384,
	"./Lophoceros alboterminatus.png": 94165,
	"./Lophoceros hemprichii.png": 73309,
	"./Lophoceros nasutus.png": 29098,
	"./Lophoictinia isura.png": 23450,
	"./Lopholaimus antarcticus.png": 1983,
	"./Lophophorus impejanus.jpg": 8858,
	"./Lophophorus sclateri.jpg": 90247,
	"./Lophotis gindiana.png": 39064,
	"./Lophotriorchis kienerii.jpg": 79774,
	"./Lophura leucomelanos.jpg": 49497,
	"./Lophura nycthemera.jpg": 818,
	"./Loriculus vernalis.png": 40605,
	"./Lymnocryptes minimus.jpg": 21482,
	"./Macheiramphus alcinus.jpg": 37177,
	"./Machlolophus nuchalis.jpg": 39649,
	"./Macronectes giganteus.png": 11716,
	"./Macronectes halli.png": 91213,
	"./Macronyx ameliae.png": 24144,
	"./Macronyx aurantiigula.png": 82414,
	"./Macronyx croceus.png": 99550,
	"./Macronyx sharpei.png": 45246,
	"./Macropygia ruficeps.png": 57424,
	"./Macropygia unchall.png": 86050,
	"./Malacorhynchus membranaceus.png": 23055,
	"./Mareca falcata.jpg": 97168,
	"./Mareca penelope.png": 3566,
	"./Marmaronetta angustirostris.jpg": 34411,
	"./Megaloprepia magnifica.png": 4970,
	"./Melierax metabates.png": 99760,
	"./Melierax poliopterus.png": 18672,
	"./Melithreptus lunatus.png": 42083,
	"./Melloria quoyi.png": 18485,
	"./Merops ornatus.png": 58873,
	"./Merops revoilii.png": 96250,
	"./Microcarbo africanus.png": 56118,
	"./Microcarbo melanoleucos.png": 17513,
	"./Microcarbo niger.jpg": 70157,
	"./Microhierax caerulescens.jpg": 18871,
	"./Microhierax fringillarius.jpg": 40083,
	"./Microhierax melanoleucos.jpg": 79753,
	"./Micronisus gabar.png": 46652,
	"./Milvus migrans.jpg": 60978,
	"./Mirafra hypermetra.png": 85628,
	"./Mirafra williamsi.png": 79380,
	"./Morus capensis.png": 95059,
	"./Morus serrator.png": 16367,
	"./Motacilla aguimp.png": 13194,
	"./Motacilla alba.png": 31111,
	"./Motacilla capensis.png": 42603,
	"./Motacilla cinerea.png": 38570,
	"./Motacilla citreola.png": 42244,
	"./Motacilla clara.png": 38522,
	"./Motacilla maderaspatensis.jpg": 26213,
	"./Motacilla samveasnae.jpg": 28741,
	"./Motacilla tschutschensis.png": 8616,
	"./Mulleripicus pulverulentus.jpg": 64421,
	"./Mycteria ibis.png": 78472,
	"./Mycteria leucocephala.jpg": 50213,
	"./Myzomela sanguinolenta.png": 87383,
	"./Necrosyrtes monachus.png": 98296,
	"./Neohierax insignis.png": 45492,
	"./Neophema chrysogaster.png": 18042,
	"./Neophema chrysostoma.png": 73698,
	"./Neophron percnopterus.jpg": 3916,
	"./Neopsephotus bourkii.png": 37211,
	"./Neotis denhami.png": 28577,
	"./Neotis heuglinii.png": 22127,
	"./Netta erythrophthalma.png": 41511,
	"./Nettapus coromandelianus.png": 99997,
	"./Nettapus pulchellus.png": 94814,
	"./Nicopsitta columboides.jpg": 93635,
	"./Ninox boobook.png": 36604,
	"./Ninox connivens.png": 57962,
	"./Ninox leucopsis.png": 63304,
	"./Ninox rufa.png": 91267,
	"./Ninox scutulata.jpg": 1690,
	"./Ninox strenua.png": 97249,
	"./Nisaetus alboniger.png": 87124,
	"./Nisaetus cirrhatus.jpg": 41870,
	"./Nisaetus nanus.jpg": 21310,
	"./Nisaetus nipalensis.jpg": 72563,
	"./Nucifraga hemispila.jpg": 47575,
	"./Nucifraga multipunctata.jpg": 62894,
	"./Numenius arquata.jpg": 71406,
	"./Numenius madagascariensis.jpg": 43996,
	"./Numenius minutus.png": 64708,
	"./Numenius phaeopus.jpg": 67952,
	"./Numenius tenuirostris.png": 54132,
	"./Nycticorax caledonicus.png": 63667,
	"./Nycticorax nycticorax.png": 60093,
	"./Nymphicus hollandicus.png": 92207,
	"./Oceanites oceanicus.jpg": 90710,
	"./Ocyceros birostris.jpg": 67675,
	"./Ocyceros griseus.jpg": 5900,
	"./Ocyphaps lophotes.png": 22246,
	"./Oena capensis.png": 11624,
	"./Onychoprion anaethetus.jpg": 79817,
	"./Onychoprion fuscatus.jpg": 70419,
	"./Oriolus mellianus.jpg": 64578,
	"./Oroanassa magnifica.jpg": 13143,
	"./Ortygornis sephaena.png": 86128,
	"./Ortyxelos meiffrenii.png": 26828,
	"./Otis tarda.png": 2376,
	"./Otus bakkamoena.jpg": 61774,
	"./Otus brucei.jpg": 9848,
	"./Otus ireneae.png": 75039,
	"./Otus lempiji.jpg": 45480,
	"./Otus lettia.jpg": 56165,
	"./Otus sagittatus.jpg": 82393,
	"./Otus scops.png": 75074,
	"./Otus senegalensis.png": 53937,
	"./Otus spilocephalus.png": 534,
	"./Otus sunia.jpg": 86364,
	"./Oxyura australis.png": 62013,
	"./Oxyura leucocephala.png": 4341,
	"./Oxyura maccoa.png": 14301,
	"./Pachyptila belcheri.png": 27862,
	"./Pachyptila desolata.png": 70135,
	"./Pachyptila turtur.png": 69946,
	"./Palaeornis eupatria.jpg": 81202,
	"./Pandion haliaetus.jpg": 70612,
	"./Pavo cristatus.jpg": 60527,
	"./Pavo muticus.jpg": 70231,
	"./Pavo muticus.png": 90119,
	"./Pedionomus torquatus.png": 38168,
	"./Pelagodroma marina.jpg": 29784,
	"./Pelargopsis amauroptera.jpg": 44963,
	"./Pelecanoides urinatrix.png": 2835,
	"./Pelecanus conspicillatus.png": 81530,
	"./Pelecanus crispus.jpg": 58646,
	"./Pelecanus onocrotalus.jpg": 6684,
	"./Pelecanus philippensis.jpg": 3727,
	"./Pelecanus rufescens.png": 81333,
	"./Peltohyas australis.png": 26612,
	"./Perdicula argoondah.jpg": 42319,
	"./Perdicula asiatica.jpg": 13865,
	"./Perdicula erythrorhyncha.jpg": 51952,
	"./Perdicula manipurensis.jpg": 11464,
	"./Perdix hodgsoniae.jpg": 31578,
	"./Pernis apivorus.png": 80287,
	"./Pernis ptilorhynchus.jpg": 74152,
	"./Phaethon aethereus.jpg": 70392,
	"./Phaethon lepturus.jpg": 67782,
	"./Phaethon rubricauda.jpg": 63998,
	"./Phalacrocorax carbo.jpg": 73411,
	"./Phalacrocorax fuscescens.png": 1594,
	"./Phalacrocorax fuscicollis.jpg": 73920,
	"./Phalacrocorax sulcirostris.png": 82692,
	"./Phalacrocorax varius.png": 5070,
	"./Phalaropus lobatus.png": 88206,
	"./Phaps histrionica.png": 15742,
	"./Philemon corniculatus.png": 74537,
	"./Phodilus badius.jpg": 4505,
	"./Phoebetria fusca.png": 4128,
	"./Phoebetria palpebrata.png": 29598,
	"./Phoeniconaias minor.jpg": 82009,
	"./Phoenicopterus roseus.jpg": 6008,
	"./Pica pica.jpg": 7035,
	"./Picus rabieri.jpg": 61543,
	"./Pitta brachyura.jpg": 91078,
	"./Pitta moluccensis.png": 21510,
	"./Pitta sordida.png": 91071,
	"./Platalea alba.png": 1791,
	"./Platalea flavipes.png": 75547,
	"./Platalea leucorodia.jpg": 97166,
	"./Platalea minor.jpg": 99572,
	"./Platalea regia.png": 67139,
	"./Platycercus caledonicus.png": 31104,
	"./Platycercus elegans.png": 70289,
	"./Platycercus venustus.png": 24431,
	"./Platysmurus leucopterus.jpg": 56653,
	"./Plegadis falcinellus.png": 83080,
	"./Ploceus golandi.png": 87964,
	"./Ploceus megarhynchus.jpg": 1248,
	"./Pluvialis fulva.jpg": 19022,
	"./Pluvialis squatarola.jpg": 76881,
	"./Podargus strigoides.png": 42563,
	"./Podica senegalensis.png": 32204,
	"./Podiceps cristatus.jpg": 91802,
	"./Podiceps grisegena.png": 39155,
	"./Podiceps nigricollis.jpg": 44263,
	"./Podoces panderi.png": 68461,
	"./Poeoptera femoralis.png": 92214,
	"./Poicephalus cryptoxanthus.png": 72270,
	"./Poicephalus gulielmi.png": 86476,
	"./Poicephalus meyeri.png": 72811,
	"./Poicephalus rufiventris.png": 58191,
	"./Polemaetus bellicosus.png": 46409,
	"./Polihierax insignis.jpg": 54307,
	"./Polihierax semitorquatus.png": 5544,
	"./Poliocephalus poliocephalus.png": 49357,
	"./Polyboroides typus.png": 54203,
	"./Polytelis alexandrae.png": 36055,
	"./Polytelis anthopeplus.png": 71961,
	"./Polytelis swainsonii.png": 89458,
	"./Porphyrio porphyrio.png": 3045,
	"./Probosciger aterrimus.png": 18772,
	"./Procellaria aequinoctialis.png": 73042,
	"./Procellaria cinerea.png": 53598,
	"./Psephotellus chrysopterygius.png": 3077,
	"./Pseudibis davisoni.png": 61376,
	"./Pseudibis papillosa.jpg": 74316,
	"./Pseudobulweria aterrima.png": 78933,
	"./Psittacula alexandri.jpg": 16389,
	"./Psittacula derbiana.jpg": 61261,
	"./Psittacus erithacus.png": 51687,
	"./Psittinus cyanurus.jpg": 1642,
	"./Pternistis afer.png": 59928,
	"./Pternistis hildebrandti.png": 12540,
	"./Pternistis jacksoni.png": 38604,
	"./Pternistis leucoscepus.png": 60399,
	"./Pternistis squamatus.png": 80402,
	"./Pterocles alchata.png": 9042,
	"./Pterocles decoratus.png": 20904,
	"./Pterocles indicus.jpg": 73867,
	"./Pterodroma arminjoniana.jpg": 91365,
	"./Pterodroma cookii.png": 74182,
	"./Pterodroma gouldi.png": 32068,
	"./Pterodroma heraldica.png": 36149,
	"./Pterodroma inexpectata.png": 68000,
	"./Pterodroma lessonii.png": 27694,
	"./Pterodroma leucoptera.png": 18742,
	"./Pterodroma mollis.png": 47048,
	"./Pterodroma nigripennis.png": 56682,
	"./Pterodroma solandri.png": 25582,
	"./Ptilinopus alligator.png": 39951,
	"./Ptilopsis granti.png": 65037,
	"./Ptilopsis leucotis.png": 3006,
	"./Ptilostomus afer.png": 68156,
	"./Pucrasia macrolopha.jpg": 29357,
	"./Puffinus assimilis.png": 55319,
	"./Puffinus bailloni.jpg": 84081,
	"./Puffinus gavia.png": 84977,
	"./Puffinus huttoni.png": 32874,
	"./Puffinus mauretanicus.png": 87772,
	"./Puffinus persicus.jpg": 28129,
	"./Puffinus yelkouan.png": 20333,
	"./Purpureicephalus spurius.png": 2375,
	"./Pycnonotus xantholaemus.jpg": 31226,
	"./Pyrrhocorax graculus.jpg": 64186,
	"./Pyrrhocorax pyrrhocorax.jpg": 84797,
	"./Radjah radjah.png": 33337,
	"./Ramphiculus jambu.jpg": 97421,
	"./Rhabdotorrhinus corrugatus.jpg": 95144,
	"./Rhinoplax vigil.jpg": 90505,
	"./Rhinoptilus bitorquatus.jpg": 72447,
	"./Rhinoptilus chalcopterus.png": 1235,
	"./Rhinoptilus cinctus.png": 25875,
	"./Rhyticeros subruficollis.jpg": 77099,
	"./Rhyticeros undulatus.jpg": 31440,
	"./Rostratula australis.png": 36218,
	"./Rostratula benghalensis.jpg": 20283,
	"./Rynchops albicollis.jpg": 65869,
	"./Rynchops flavirostris.png": 51501,
	"./Sagittarius serpentarius.png": 8574,
	"./Sarcogyps calvus.jpg": 30266,
	"./Saundersilarus saundersi.jpg": 58504,
	"./Saxicola insignis.jpg": 13,
	"./Saxicola macrorhynchus.jpg": 35793,
	"./Scleroptila gutturalis.png": 36677,
	"./Scleroptila levaillantii.png": 49839,
	"./Scleroptila shelleyi.png": 22290,
	"./Scleroptila streptophora.png": 31064,
	"./Scolopax rusticola.jpg": 1724,
	"./Scopus umbretta.png": 31804,
	"./Scotopelia peli.png": 33692,
	"./Scythrops novaehollandiae.png": 39758,
	"./Sheppardia gunningi.png": 38769,
	"./Sholicola albiventris.jpg": 63022,
	"./Sholicola major.jpg": 12172,
	"./Smutsornis africanus.png": 88112,
	"./Spatula clypeata.png": 99354,
	"./Spatula rhynchotis.png": 63336,
	"./Spilopelia chinensis.png": 76123,
	"./Spilopelia senegalensis.png": 29872,
	"./Spilornis cheela.jpg": 26340,
	"./Stephanoaetus coronatus.png": 37677,
	"./Stercorarius longicaudus.png": 13295,
	"./Stercorarius parasiticus.png": 4937,
	"./Stercorarius pomarinus.jpg": 54231,
	"./Sterna acuticauda.jpg": 62308,
	"./Sterna aurantia.jpg": 17865,
	"./Sterna dougallii.jpg": 92528,
	"./Sterna hirundo.jpg": 35821,
	"./Sterna repressa.jpg": 83313,
	"./Sterna striata.png": 8760,
	"./Sterna sumatrana.jpg": 18892,
	"./Sternula albifrons.jpg": 68813,
	"./Sternula nereis.png": 76427,
	"./Sternula saundersi.jpg": 42157,
	"./Stictonetta naevosa.png": 43658,
	"./Stiltia isabella.png": 93710,
	"./Strepera fuliginosa.png": 65882,
	"./Strepera graculina.png": 77971,
	"./Strepera versicolor.png": 86849,
	"./Streptopelia capicola.png": 49977,
	"./Streptopelia decipiens.png": 14611,
	"./Streptopelia lugens.png": 81143,
	"./Streptopelia orientalis.png": 92895,
	"./Streptopelia reichenowi.png": 40768,
	"./Streptopelia semitorquata.png": 17750,
	"./Streptopelia tranquebarica.png": 61021,
	"./Streptopelia turtur.png": 99153,
	"./Strix aluco.jpg": 56449,
	"./Strix leptogrammica.png": 18920,
	"./Strix nivicolum.jpg": 40883,
	"./Strix ocellata.jpg": 19434,
	"./Strix seloputo.jpg": 26506,
	"./Strix woodfordii.png": 80673,
	"./Struthidea cinerea.png": 1267,
	"./Sula dactylatra.jpg": 70777,
	"./Sula leucogaster.jpg": 57068,
	"./Sula sula.jpg": 49627,
	"./Synoicus chinensis.jpg": 7156,
	"./Sypheotides indicus.jpg": 34437,
	"./Syrmaticus humiae.jpg": 95884,
	"./Tachybaptus novaehollandiae.png": 17177,
	"./Tachybaptus ruficollis.png": 68869,
	"./Tadorna tadornoides.png": 34804,
	"./Temnurus temnurus.jpg": 4431,
	"./Terathopius ecaudatus.png": 54076,
	"./Tetraogallus himalayensis.jpg": 57161,
	"./Tetraogallus tibetanus.jpg": 38201,
	"./Tetraophasis szechenyii.jpg": 13935,
	"./Tetrax tetrax.png": 91057,
	"./Thalassarche bulleri.png": 78281,
	"./Thalassarche carteri.png": 68042,
	"./Thalassarche cauta.png": 45286,
	"./Thalassarche chrysostoma.png": 2140,
	"./Thalassarche impavida.png": 57857,
	"./Thalassarche melanophris.png": 39278,
	"./Thalassarche salvini.png": 51174,
	"./Thalassarche steadi.png": 7990,
	"./Thalasseus bengalensis.jpg": 72001,
	"./Thalasseus bergii.jpg": 77252,
	"./Thalasseus bernsteini.jpg": 96999,
	"./Thalasseus sandvicensis.jpg": 53892,
	"./Thaumatibis gigantea.png": 9110,
	"./Thinornis cucullatus.png": 34566,
	"./Threskiornis aethiopicus.png": 93678,
	"./Threskiornis melanocephalus.jpg": 38991,
	"./Threskiornis moluccus.png": 51037,
	"./Threskiornis spinicollis.png": 52663,
	"./Tmetothylacus tenellus.png": 48533,
	"./Tockus deckeni.png": 28279,
	"./Tockus erythrorhynchus.png": 14001,
	"./Tockus jacksoni.png": 54954,
	"./Todiramphus chloris.png": 81707,
	"./Todiramphus sanctus.png": 99964,
	"./Torgos tracheliotos.png": 98192,
	"./Treron apicauda.png": 66677,
	"./Treron bicinctus.png": 16075,
	"./Treron calvus.png": 17595,
	"./Treron capellei.jpg": 53978,
	"./Treron curvirostra.png": 52523,
	"./Treron fulvicollis.jpg": 29549,
	"./Treron phayrei.jpg": 69559,
	"./Treron phoenicopterus.png": 90689,
	"./Treron seimundi.png": 18191,
	"./Treron sieboldii.png": 87871,
	"./Treron sphenurus.png": 49942,
	"./Treron waalia.png": 53660,
	"./Trichoglossus moluccanus.png": 12716,
	"./Trichoglossus rubritorquis.png": 27675,
	"./Trigonoceps occipitalis.png": 28864,
	"./Tringa brevipes.jpg": 48882,
	"./Tringa erythropus.jpg": 74493,
	"./Tringa glareola.jpg": 74037,
	"./Tringa guttifer.jpg": 8388,
	"./Tringa nebularia.jpg": 55753,
	"./Tringa ochropus.jpg": 69169,
	"./Tringa stagnatilis.jpg": 80243,
	"./Tringa totanus.jpg": 66182,
	"./Turdus feae.png": 3237,
	"./Turdus helleri.png": 90055,
	"./Turnix maculosus.png": 71923,
	"./Turnix pyrrhothorax.png": 95485,
	"./Turnix suscitator.jpg": 26026,
	"./Turnix sylvaticus.jpg": 93266,
	"./Turnix tanki.jpg": 90318,
	"./Turnix velox.png": 96167,
	"./Turtur afer.png": 99951,
	"./Turtur chalcospilos.png": 23635,
	"./Turtur tympanistria.png": 14372,
	"./Tyto alba.jpg": 34959,
	"./Tyto capensis.png": 87283,
	"./Tyto longimembris.jpg": 31329,
	"./Tyto multipunctata.png": 44528,
	"./Tyto novaehollandiae.png": 81345,
	"./Tyto tenebricosa.png": 9826,
	"./Upupa epops.png": 87305,
	"./Urocissa erythroryncha.jpg": 59110,
	"./Urocissa flavirostris.jpg": 57738,
	"./Urocissa xanthomelana.jpg": 25232,
	"./Vanellus armatus.png": 83984,
	"./Vanellus cinereus.jpg": 59021,
	"./Vanellus coronatus.png": 9685,
	"./Vanellus crassirostris.png": 5166,
	"./Vanellus duvaucelii.jpg": 43654,
	"./Vanellus gregarius.jpg": 35286,
	"./Vanellus indicus.jpg": 52166,
	"./Vanellus leucurus.jpg": 71249,
	"./Vanellus lugubris.png": 83156,
	"./Vanellus malabaricus.jpg": 12911,
	"./Vanellus melanopterus.png": 31770,
	"./Vanellus miles.png": 47995,
	"./Vanellus senegallus.png": 6554,
	"./Vanellus spinosus.png": 49799,
	"./Vanellus superciliosus.png": 64923,
	"./Vanellus tectus.png": 59361,
	"./Vanellus tricolor.png": 75753,
	"./Vanellus vanellus.jpg": 23937,
	"./Xenus cinereus.jpg": 70342,
	"./Zanda baudinii.png": 42300,
	"./Zanda funerea.png": 39527,
	"./Zanda latirostris.png": 81937,
	"./Zapornia akool.jpg": 89809,
	"./Zapornia paykullii.jpg": 93135,
	"./Zoonavena sylvatica.jpg": 71168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82569;